const configPortfolio = {
    portfolio: {
        listLayout: 'PortfolioListDefaultLayout',
        filterLayout: 'PortfolioFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getPortfolio',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
    },
}
import util from "@/mixins/util";

export default {
    methods: {
        returnPortfolioConfig(type) {
            return configPortfolio[type];
        },

    },
    filterConfig: {
        cr: {
            type: 'between',
            classname: 'filterDate'
        },
        al: {
            type: 'between',
            classname: 'filterDate'
        },
        out: {
            type: 'between',
            classname: 'filterOutDate'
        },
        ni: {
            type: 'query',
            classname: 'searchInput',
        },
        mid: {
            type: 'query',
            classname: 'searchInput',
        },
        bid: {
            type: 'query',
            classname: 'filterStatus',
        },
        bl: {
            type: 'match',
            classname: 'filterStatus',
        },
        cmty:{
            type: 'terms',
            classname: 'filterType',
        }

    }
}
